<div class="card-title-block-non-sticky">
	<div class="card-title-label" translate>offer.dashboard.services</div>
</div>
<div class="service-grid-container copo-container">

	<copo-check-offer-widget *ngIf="user.hasService('ND4ST')"
		headerLabel="arcelormittal.need4steel.entry"
		btnLabel="check.new.offer"
		btnRouterLink="/need4steel/offerlist">
	</copo-check-offer-widget>

	<copo-create-fastlane-widget *ngIf="user.hasService('PFAST')"
		headerLabel="fast.lane.entry"
		btnLabel="create.new.request"
		btnRouterLink="/fastlane/wizard">
	</copo-create-fastlane-widget>

	<copo-request-offer-widget *ngIf="user.hasService('EOFFR') && user.isOfferValidator()"
		headerLabel="eoffer.entry"
		btnLabel="eoffer.request.new.offer"
		btnRouterLink="/offer/wizard">
	</copo-request-offer-widget>

	<copo-request-guarantee-widget *ngIf="user.hasService('PGNTE')"
		headerLabel="quality.guarantee.request"
		btnLabel="claim.guarantee.request"
		btnRouterLink="/guarantee-requests/new/guarantee-type-selector">
	</copo-request-guarantee-widget>

	<copo-create-order-widget *ngIf="user.hasService('EORDR')"
		headerLabel="order.entry"
		btnLabel="create.new.order"
		btnRouterLink="/order/wizard">
	</copo-create-order-widget>

	<copo-auction-offer-widget *ngIf="user.hasService('PAUCT')"
		headerLabel="auction.entry"
		btnLabel="auction.new.offer.check"
		btnRouterLink="/auction/bidding/offer-selection">
	</copo-auction-offer-widget>

	<copo-request-claim-widget *ngIf="user.hasService('QUAPP') && (user.isClaimDetector() || user.isClaimValidator())"
		headerLabel="claim.dashboard.services.claims"
		btnLabel="claim.raise-new-quality-issue"
		btnRouterLink="/quality-issues/new/batch-selection">
	</copo-request-claim-widget>

	<copo-eaqdb-widget *ngIf="user.hasService('PAQDB')"
		headerLabel="aqdb.label"
		btnLabel="aqdb.quality.data"
		btnRouterLink="/aqdb/datacenter">
	</copo-eaqdb-widget>

	<copo-coil-calculator-widget
		headerLabel="label.coil.calculator"
		btnLabel="label.calculation"
		btnRouterLink="/calculator/coil-calculator">
	</copo-coil-calculator-widget>

	<copo-efeasibility-widget *ngIf="user.hasService('PFEAS')"
		headerLabel="dashboard.efeasibility"
		btnLabel="dashboard.efeasibility.add.new"
		btnRouterLink="/efeasibility/dashboard">
	</copo-efeasibility-widget>
</div>